import { useEffect, useRef, useState } from 'react';

export default function AboutSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="about"
      ref={ref}
      className="py-24 lg:py-36 px-6 lg:px-12 bg-[#faf8f5]"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        {/* Image */}
        <div
          className={`relative transition-all duration-1000 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
        >
          <div className="relative">
            <div className="w-full h-[500px] lg:h-[620px] overflow-hidden rounded-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/f3aef7eb15969d577090ee1a3a53a194.jpg"
                alt="Bloom Flower Studio - スタジオ内観"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Decorative frame */}
            <div className="absolute -bottom-6 -right-6 w-2/3 h-2/3 border border-[#c4956a]/30 rounded-lg -z-10"></div>
          </div>
        </div>

        {/* Text */}
        <div
          className={`transition-all duration-1000 delay-200 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}
        >
          <p className="font-noto text-xs tracking-[0.4em] text-[#c4956a] uppercase mb-6">About Us</p>
          <h2 className="font-cormorant text-5xl lg:text-6xl text-[#2c2218] font-light leading-tight mb-8">
            花と共に、<br />
            <span className="italic">記憶に残る</span><br />
            一瞬を創る
          </h2>
          <p className="font-noto text-sm text-[#6b5c4e] leading-relaxed mb-6">
            Bloom Flower Studioは、上質な花材と繊細なデザインセンスで、あなたの大切な瞬間を美しく彩るフラワーアレンジメントスタジオです。
          </p>
          <p className="font-noto text-sm text-[#6b5c4e] leading-relaxed mb-10">
            ウェディングセレモニーからフォトウェディング、日常のフラワーギフトまで、一つひとつ丁寧に、お客様の想いを花に込めてお届けします。季節の花を活かした唯一無二のスタイルで、特別な時間を演出します。
          </p>

          <div className="grid grid-cols-3 gap-6 pt-8 border-t border-[#e8ddd0]">
            {[
              { num: '500+', label: 'Wedding実績' },
              { num: '8年', label: 'スタジオ経歴' },
              { num: '98%', label: 'お客様満足度' },
            ].map(stat => (
              <div key={stat.label}>
                <p className="font-cormorant text-4xl text-[#c4956a] font-light">{stat.num}</p>
                <p className="font-noto text-xs text-[#6b5c4e] tracking-wider mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
